import classnames from 'classnames';
import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import { BasicNumberFormatterProps } from 'components/shared/NumberFormatter/NumberFormatter.model';
import { WithUnit, WithUnitProps } from 'components/shared/WithUnit/WithUnit';
import { FC } from 'react';

export const NumberFormatterWithUnit: FC<BasicNumberFormatterProps & WithUnitProps> = props => {
  return (
    <WithUnit
      hasError={props.hasError}
      isDisabled={props.isDisabled || props.isLoading}
      isReadOnly={props.isReadOnly}
      unit={props.unit}
      className={classnames(props.className)}
      e2e={props.id}
    >
      <NumberFormatter {...props} />
    </WithUnit>
  );
};
